///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case = abcsetup.set_case || {};
abcsetup.set_case.users = abcsetup.set_case.users || {};
abcsetup.set_case.users.create = abcsetup.set_case.users.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case.users.create = {
    init: function() {
        // init the SET common lib
        abcsetup.set_case.users.common.init();
    },

    bindFields: function () {
        // Bind any fields events
    },
}